import styled from 'styled-components';
import { Button } from '@m/alchemy-ui/Button';
import { Field } from '@m/alchemy-ui/Field';
import { Input } from '@m/alchemy-ui/Input';
import { color, typeStyle, units } from '@m/alchemy-ui/theme';

export const MfaPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
`;

export const MfaMain = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const MfaHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${units(3)};
  width: 100%;
`;

export const MfaLogo = styled.div`
  img {
    max-width: 300px;
    max-height: 60px;
    object-fit: contain;
  }
`;

export const MfaTitle = styled.h2`
  font-weight: 700;
  font-size: 20px;
  margin: 0;
  padding: 0;
`;

export const MfaSubheading = styled.span`
  ${typeStyle('bodyS')};
  color: ${color('typeMeta', { palette: 'structural' })};
  margin-left: auto;
`;

export const MfaHeadline = styled.h1`
  font-weight: 700;
  font-size: 24px;
  text-align: center;
  margin: 0 0 ${units(3)} 0;
  padding: 0;
  width: 100%;
`;

export const QrCodeContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${units(3)};
  margin-bottom: ${units(3)};
  background: #ffffff;
  border: 1px solid ${color('line')};
  border-radius: 8px;
`;

export const MfaFormContainer = styled.div`
  width: 100%;

  @media (min-width: 800px) {
    max-width: 358px;
    margin: 0 auto;
  }
`;

export const StyledField = styled(Field)`
  margin-bottom: ${units(0.5)};
  label {
    font-size: 14px;
    font-weight: 400;
    color: #1b2437;
  }
`;

export const StyledInput = styled(Input)`
  input {
    box-sizing: border-box;
    width: 100%;
  }
`;

export const HelperText = styled.p`
  ${typeStyle('bodyS')};
  color: ${color('typeMeta', { palette: 'structural' })};
  margin: 0 0 ${units(2)} 0;
`;

export const ErrorAlert = styled.div.attrs({ className: 'mdl-alert -error' })`
  margin-bottom: ${units(2)};
  width: 100%;
`;

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: ${units(2.5)};
  padding: ${units(2)} 0;
  border-top: 1px solid ${color('line')};
`;

export const SubmitButton = styled(Button)``;
